<template>
  <div class="router-transitions">
    <vue-snotify/>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app-layout-blank'
}
</script>
